
import $ from 'jquery';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';
import mergeOptions from 'styleguide/lib/merge-options';
import Bloodhound from 'vendor/typeahead'; // Load typeahead jQuery plugin

export const PLUGIN_NAME = 'inputSuggestion';
export const FOCUS_EVENT = 'focus';
export const DEFAULTS = {};


	var states = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California',
	  'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii',
	  'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana',
	  'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
	  'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
	  'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
	  'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island',
	  'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
	  'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
	];


	var states = new Bloodhound({
	  datumTokenizer: Bloodhound.tokenizers.whitespace,
	  queryTokenizer: Bloodhound.tokenizers.whitespace,
	  // `states` is an array of state names defined in "The Basics"
	  local: states
	});

    var cities_kw = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        prefetch: {
            url: '/r/js/checkout/cities_kw.json',
            cache: false
        }
    });

    var cities_il = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        prefetch: '/r/js/checkout/cities_il.json'
    });

  const itemClickHandler = ($el, opts = {}) => {
  	var dataSource = states;
  	var dataName = 'states';
  	if($($el).hasClass('typeahead_il')) {
        dataSource = cities_il;
        dataName = 'cities';
	} else if($($el).hasClass('typeahead_kw')) {
        dataSource = cities_kw;
        dataName = 'cities';
    }
        $($el).typeahead({
		  hint: true,
		  highlight: false,
		  minLength: 1
		},
		{
		  name: dataName,
		  source: dataSource
		});
  };



  /**
   * Applies any sort of event handlers for the toggleContent.
   * @private
   * @param {jQuery} $el - Containing the elements for the toggleContent
   * @param {Object} options - Options used for wiring up the toggleContent
   * @see DEFAULTS
   */
  // const applyEventHandlers = ($el, opts = {}) => {
  //   $el
  //     .on(FOCUS_EVENT, evt => itemClickHandler(evt, $el, opts));
  // };

  /**
   * Initializes an toggleContent based on provided parameters.
   * @param {HTMLElement} el - An element containing the elements for the
   * toggleContent
   * @param {Object} options - Options used for wiring up the toggleContent
   * @see DEFAULTS
   */
  export default function inputSuggestion(el, options = {}) {
    const $el = $(el);
    const opts = mergeOptions(DEFAULTS, options, $el);
    itemClickHandler($el, opts);
  }

  // Expose the function as a jQuery plugin for ease of use
  registerJQueryPlugin(PLUGIN_NAME, inputSuggestion);



// WEBPACK FOOTER //
// ./src/scripts/modules/input-suggestion.js